import React, { ReactNode } from 'react';
import AdminLogo from './admin-logo';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import AccountCircle from '@mui/icons-material/AccountCircle';

interface HeaderProps {
  pageTitle?: string;
  avatarImg?: string;
}

function Header({ pageTitle, avatarImg }: HeaderProps) {
  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        boxShadow: 'none',
        padding: '0 20px',
        margin: '-10px -20px 0 -20px',
        height: 'fit-content',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '50px', height: '70px', mr: 1 }}>
            <AdminLogo />
          </Box>
          <Typography variant="h5" color="black">
            MessageFlow
          </Typography>

          <Divider
            orientation="vertical"
            variant="middle"
            sx={{ mx: 1, py: 1 }}
            flexItem
          />

          <Typography variant="h6" color="black">
            {pageTitle}
          </Typography>
        </Box>

        <Box>
          <Tooltip title="Account dashboard">
            <IconButton href="https://messageflow.co" sx={{ p: 0 }}>
              {Boolean(avatarImg) ? (
                <Avatar alt="account avatar" src={avatarImg} />
              ) : (
                <AccountCircle fontSize="large" />
              )}
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
}

interface FooterProps {
  version?: string;
  fixed?: boolean;
}

function Footer({ version, fixed }: FooterProps) {
  return (
    <Box
      sx={{
        backgroundColor: 'transparent',
        textAlign: 'end',
        position: fixed ? 'fixed' : 'absolute',
        bottom: '5vh',
        right: '2vw',
      }}
    >
      <Typography variant="caption">
        MessageFlow version {version}, by{' '}
        <Typography
          sx={{
            textDecoration: 'none',
            color: 'primary.main',
          }}
          variant="caption"
          component="a"
          href="https://messageflow.co"
        >
          Autoserve
        </Typography>
      </Typography>
    </Box>
  );
}

export type AdminLayoutProps = {
  children?: ReactNode;
  pageTitle?: string;
  avatarImg?: string;
  version?: string;
  fixedFooter?: boolean;
};

export function AdminLayout({
  children,
  pageTitle,
  avatarImg,
  version,
  fixedFooter = false,
}: AdminLayoutProps) {
  return (
    <>
      <Header pageTitle={pageTitle} avatarImg={avatarImg} />
      {children}
      <Footer version={version} fixed={fixedFooter} />
    </>
  );
}
